import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import styles from './styles.module.scss';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import ApiService from './../../network/ApiService';
import SecureFilePicker from '../../components/SecureFilePicker';

const SetTrainerForm = ({ teamID }) => {
    const [coachImageURL, setCoachImageURL] = useState(null);
    const [coachImage, setCoachImage] = useState(null);
    const navigate = useNavigate();
    const apiServiceRef = useRef(new ApiService());

    const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm({
        defaultValues: {
            coachName: '',
            coachEmail: '',
            coachImageURL: '',
        }
    });

    useEffect(() => {
        const fetchTeam = async () => {
            try {
                const response = await apiServiceRef.current.get(`app/team/${teamID}`);
                if (response) {
                    if (response.coach) {
                        if (response.coach.name) setValue('coachName', response.coach.name);
                        if (response.coach.email) setValue('coachEmail', response.coach.email);
                        if (response.coach.image) {
                            setCoachImageURL(response.coach.image);
                        }
                    }
                }
            } catch (error) {
                console.error('Failed to fetch team data.');
            }
        };

        if (teamID) {
            fetchTeam();
        }
    }, [teamID, setValue]);

    const onSubmit = async (data) => {
        try {
            const body = coachImage ? new FormData() : {
                name: data.coachName,
                email: data.coachEmail,
            };
            if (body instanceof FormData) {
                body.append('name', data.coachName);
                body.append('email', data.coachEmail);
                body.append('image', coachImage, coachImage.name);
            }
            await apiServiceRef.current.put(`app/trainer/${teamID}`, body);
            navigate('/kader');
        } catch (error) {
            console.error('Failed to update the trainer.');
        }
    };

    return (
        <form className={styles.formContainer} onSubmit={handleSubmit(onSubmit)}>
            {coachImageURL && (
                <div className={styles.imagePreviewContainer}>
                    <img className={styles.imagePreview} src={coachImageURL} alt="Coach" />
                </div>
            )}
            <div className={styles.row}>
                <input
                    className={classNames('field', { 'field--error': errors.coachName })}
                    type="text"
                    placeholder="Trainer Name"
                    {...register('coachName', { required: true })}
                />
            </div>
            <div className={styles.row}>
                <input
                    className={classNames('field', { 'field--error': errors.coachEmail })}
                    type="email"
                    placeholder="Trainer Email"
                    {...register('coachEmail', { required: true })}
                />
            </div>
            <div className={styles.row}>
                <SecureFilePicker
                    onSelect={setCoachImage}
                    buttonText={"Trainer Foto auswahl"}
                    accept="image/png,image/jpeg"
                />
            </div>
            <div className={styles.footer}>
                <button className="btn" type="submit">Trainer Aktualisieren</button>
                <button className="btn btn--outlined" type="reset" onClick={() => reset()}>Reset</button>
            </div>
        </form>
    );
};

SetTrainerForm.propTypes = {
    teamID: PropTypes.string.isRequired,
};

export default SetTrainerForm;
